module.exports = "<div class=\"container\">\n  <h2>\n    Nalgene Bottle and Carboy Selection Guide\n  </h2>\n  <app-categories></app-categories>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// /Users/thomas.obrien2/projects/nalgene/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main